import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TElogo from "../../../../assets/images/dod_logo.png";
import { Toaster } from "../../../components/Toaster/Toster";
import BtnLoader from "../../../components/Loader/btnLoader";
import Swal from "sweetalert2";
import { adminNewPasswordApi } from "../../../../services/apis/AuthService";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from 'react-device-detect';
import { CreatelogActivityApi, pass_systemIpAddress, systemIpAddress } from "../../../../services/apis/IpAddress";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";

function AdminChangePasswordSection() {
  let errorsObj = { newPassword: "", confirmPassword: "" };
   const location = useLocation()?.state;
  const [errors, setErrors] = useState(errorsObj);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [informationIp, setInformationIp] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const deviceType = {
    type: isMobile ? "Mobile" : isTablet ? "Tablet" : isDesktop ? "Desktop" : "Unknown",
    os: isAndroid ? "Android" : isIOS ? "iOS" : "Other"
  };
  const navigate = useNavigate();

  // Validation logic
  const validateFields = () => {
    const errorObj = { newPassword: "", confirmPassword: "" };
    let isError = false;

    if (!newPassword) {
      errorObj.newPassword = "New password is required";
      isError = true;
    } else if (newPassword.length < 8) {
      errorObj.newPassword = "Password must be at least 8 characters long";
      isError = true;
    }

    if (!confirmPassword) {
      errorObj.confirmPassword = "Confirm password is required";
      isError = true;
    } else if (newPassword !== confirmPassword) {
      errorObj.confirmPassword = "Passwords do not match";
      isError = true;
    }

    setErrors(errorObj);
    return isError;
  };

  // Handle input change
  const handleInputChange = (e, field) => {
    if (field === "newPassword") {
      setNewPassword(e.target.value);
      if (submitted && errors.newPassword) {
        setErrors((prevErrors) => ({ ...prevErrors, newPassword: "" }));
      }
    } else if (field === "confirmPassword") {
      setConfirmPassword(e.target.value);
      if (submitted && errors.confirmPassword) {
        setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: "" }));
      }
    }
  };

       // log activity-------------------------
      const SystemIp = async () => {
        try {
          await systemIpAddress()
            .then((response) => {
              passIpAddress(response?.data?.ip)
            })
        } catch (err) {
          console.log(err)
        }
      }
    
      const passIpAddress = async (ipv4) => {
        try {
          await pass_systemIpAddress(ipv4)
            .then((response) => {
              setInformationIp(response?.data)
            })
        } catch (err) {
          console.log(err)
        }
      }
    
      useEffect(() => {
        SystemIp();
      }, []);
    
      const loggedActivity = async (id) => {
        const data = {
          id:id,
          ipAddress: informationIp?.query,
          lat: informationIp?.lat,
          long: informationIp?.lon,
          logType:'changepassword',
          deviceType: JSON.stringify(deviceType),
          city: informationIp?.city,
          countryCode: informationIp?.countryCode,
          regionCode: informationIp?.region
        }
        try {
          await CreatelogActivityApi(data)
        } catch (err) {
          console.log(err)
        }
      }
  

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (validateFields()) {
      return;
    }
    setBtnLoading(true);
    const formData = {
      email:location?.email,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };
    try {
      const res = await adminNewPasswordApi(formData);
      const resData = res?.data;
      // console.log("resss", resData);
      loggedActivity(resData?.user?._id);
      if (resData?.success) {
         Swal.fire({
           icon: "success",
           title: "Password Changed Successful",
           text: res?.data?.message,
         });
        navigate("/login");
        
      } else {
        console.log("Password reset failed");
      }
    } catch (error) {
      Toaster.error(error.response?.data?.message);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="fix-wrapper py-0">
        <div className="login-mainsection-background">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg-12 login-right-section d-flex flex-column justify-content-center">
                <div className="login-right-content-section">
                  <div className="card login-card mb-0 h-auto">
                    <div className="card-body">
                      <div className="d-flex justify-content-center mb-2">
                        <Link to={"/dashboard"}>
                          <img
                            src={TElogo}
                            alt="logo"
                            style={{ height: "80px", width: "auto" }}
                          />
                        </Link>
                      </div>
                      <h4 className="login-welcome-text">Change Password</h4>
                       <p className="mb-3 text-black">
                         Enter your new password and confirm it to reset.
                       </p>
                      <form onSubmit={onSubmit}>
                        <div className="mb-3">
                          <label className="mb-1 text-dark">
                            <strong>New Password</strong>
                          </label>
                          <div className="position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            value={newPassword}
                            onChange={(e) => handleInputChange(e, "newPassword")}
                            placeholder="Type your new password"
                          />
                           <span
                               className="user-eyeicon-div"
                               onClick={()=>setShowPassword(!showPassword)}>
                               {showPassword ? (
                                 <IoMdEyeOff size={22} />
                               ) : (
                                 <IoEye size={22} />
                               )}
                            </span>
                            </div>
                          {errors.newPassword && (
                            <div className="text-danger fs-12">
                              {errors.newPassword}
                            </div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="mb-1 text-dark">
                            <strong>Confirm Password</strong>
                          </label>
                          <div className="position-relative">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            className="form-control"
                            value={confirmPassword}
                            onChange={(e) =>
                              handleInputChange(e, "confirmPassword")
                            }
                            placeholder="Confirm your new password"
                          />
                           <span
                               className="user-eyeicon-div"
                               onClick={()=>setShowConfirmPassword(!showConfirmPassword)}>
                               {showConfirmPassword ? (
                                 <IoMdEyeOff size={22} />
                               ) : (
                                 <IoEye size={22} />
                               )}
                            </span>
                            </div>
                          {errors.confirmPassword && (
                            <div className="text-danger fs-12">
                              {errors.confirmPassword}
                            </div>
                          )}
                        </div>
                        <div className="text-center mt-4">
                          <button
                            type="submit"
                            className="btn text-white btn-block handle-login-btn">
                            {btnLoading && <BtnLoader />}
                            Change Password
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminChangePasswordSection;
